<template>
    <section class="disclaimer-main">
        <h1>Disclaimer</h1>
        <div class="disclaimer-text">

<p>If you require any more information or have any questions about our site's disclaimer, please feel free to contact us by email at info@yourcarsold.com.au.</p>

<h2>Disclaimers for Your Car Sold</h2>

<p>All the information on this website - https://www.yourcarsold.com.au - is published in good faith and for general information purpose only. Your Car Sold does not make any warranties about the completeness, reliability and accuracy of this information. Any action you take upon the information you find on this website (Your Car Sold), is strictly at your own risk. Your Car Sold will not be liable for any losses and/or damages in connection with the use of our website.</p>

<p>From our website, you can visit other websites by following hyperlinks to such external sites. While we strive to provide only quality links to useful and ethical websites, we have no control over the content and nature of these sites. These links to other websites do not imply a recommendation for all the content found on these sites. Site owners and content may change without notice and may occur before we have the opportunity to remove a link which may have gone 'bad'.</p>

<p>Please be also aware that when you leave our website, other sites may have different privacy policies and terms which are beyond our control. Please be sure to check the Privacy Policies of these sites as well as their "Terms of Service" before engaging in any business or uploading any information.</p>

<h2>Consent</h2>

<p>By using our website, you hereby consent to our disclaimer and agree to its terms.</p>

<h2>Update</h2>

<p>Should we update, amend or make any changes to this document, those changes will be prominently posted here.</p>
        </div>
    </section>

</template>

<script>
export default {
    name: 'disclaimer',
    metaInfo: {
        title: 'Disclaimer',
        titleTemplate: '%s | YourCarSold.com.au'
    },
}
</script>

<style scoped>
    .disclaimer-main {
        padding: 150px 20px 20px 20px;
        height: 100vh;
        width: 100%;
    }

    .disclaimer-text {
        padding: 20px 10px;
        text-align: justify;
        background-color: rgb(0, 0, 0, 0.9);
        border-radius: 4px;
        border: 1px solid #00B5E2;
        margin: 0 auto;
        max-width: 960px;
    }

    p {
        padding: 10px 0px;
    }
</style>